import { VendureUserIdentity } from "@scalingworks/refine-react-admin/src/types";
import { currentChannelToken } from "~/config/auth-provider";

export const getChannel = (identity: VendureUserIdentity) => {
  const channelToken = localStorage.getItem(currentChannelToken);
  const channel = identity.me?.channels?.find(channel => channel.token === channelToken);

  return channel;
}